import React from 'react';
import ReactDOM from 'react-dom';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMDashboardBaseView extends React.Component {

  constructor(props) {
    super(props);
    this.splitViewModalContainer = null;
  }

  addSplitViewModal(container) {
    let modal = $(
      '<div id="js-split_view-dialog" class="maincol-lightbox js-scroller__overflow" />'
    );
    this.splitViewModalContainer = container;
    modal.hide();
    $(this.splitViewModalContainer).append(modal);
    $("#js-split_view-dialog").
      on("mousedown", ()=>{
        this.hideDialog();
      }).
      on("touchstart", ()=>{
        this.hideDialog();
      });
    window.addEventListener('resize', this.modalSizeToFit.bind(this), false);
    this.modalSizeToFit();

    $(document).on("SMHideDialog", (e)=> {
      this.hideDialog();
    });
    if (SMAppHelper.isMobile()) SMAppHelper.canBodyScroll(true);
  }

  showDialog(el) {
    let $dialog = $("#js-split_view-dialog");
    ReactDOM.render(el, $dialog.get(0));
    $dialog.find("> *").
      on("mousedown", function(e){
        e.stopPropagation();
      }).
      on("touchstart", function(e){
        e.stopPropagation();
      });
    setTimeout(function(){
      $dialog.fadeIn();
    }, 1);
    this.modalSizeToFit();

    if (SMAppHelper.isMobile()) SMAppHelper.canBodyScroll(false);
  }

  hideDialog() {
    let $dialog = $("#js-split_view-dialog");
    $dialog.find("> *").
      off("mousedown").
      off("touchstart");
    $dialog.fadeOut(function(){
      ReactDOM.unmountComponentAtNode($dialog.get(0));
    });
    if (SMAppHelper.isMobile()) SMAppHelper.canBodyScroll(true);
  }

  removeSplitViewModal() {
    window.removeEventListener('resize', this.modalSizeToFit.bind(this), false);
  }

  modalSizeToFit() {
    let $header = $('#js-dashboard-header-navigation'),
        $footer = $('#js-dashboard-footer'),
        $table_footer = $('.js-dashboard-main-table-footer'),
        $mainTable = $(this.splitViewModalContainer),
        height = $(window).outerHeight(),
        offset;

    if (!SMAppHelper.isMobile()) {
      offset = $mainTable.offset();
      height = height
        - ($header.offset().top || 0)
        - ($header.outerHeight() || 0)
        - ($table_footer.outerHeight() || 0)
        - ($footer.outerHeight() || 0);
    } else {
      offset = {top:0, left:0};
      height = "100vh";
    }
    if (offset !== undefined) {
      $("#js-split_view-dialog").
      outerHeight(height).
      outerWidth($mainTable.outerWidth()).
      css(offset);
    }
  }

  applyResponsive(){
    if ($(window).width() <= SMAppHelper.maxMobileWidth()) {
      this.sizeToResponsive();
    }
  }

  sizeToResponsive(){
    let $body = $("body");
    $body.addClass("sp");
    if (this.props.action == "show") {
      $body.addClass("sp-maincol");
    } else {
      $body.addClass("sp-sidecol");
    }
    $body.css({overflow : "auto"});
    $(".js-scroller").css({overflow: "auto", height: "auto", minHeight: "20vh"});
  }
}
export default SMDashboardBaseView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMDashboardBaseView.jsx